export enum CalculateReorderOrderBy {
	Title = 'Title',
	Incoming = 'Incoming',
	Verified = 'Verified',
	Min = 'Min',
	Max = 'Max',
	Order = 'Order',
}
